<div class="wrapper">
  <div *ngIf="fundraiser?.doctor?.info_1 || fundraiser?.hospital?.full_name" class="details">
    <div *ngIf="fundraiser?.doctor?.info_1" class="doctor">
      <div class="logo"><img loading="lazy" [attr.data-src]="fundraiser?.doctoravatar?.cdn_path || '/assets/images/stethoscope.png'" alt="Doctor logo"></div>
      <div class="desc">
        <div class="title">{{'Stories.contact.assignee' | translatePipe | async}}</div>
        <div class="name">{{fundraiser?.doctor?.info_1}}</div>
      </div>
    </div>
    <div *ngIf="fundraiser?.hospital?.full_name" class="hospital">
      <div *ngIf="fundraiser?.hospitallogo?.cdn_path" class="logo"><img loading="lazy" [attr.data-src]="fundraiser?.hospitallogo?.cdn_path" alt="Hospital logo"></div>
      <div *ngIf="!fundraiser?.hospitallogo?.cdn_path" class="circle"><i class="icon-red-cross"></i></div>
      <div class="desc">
        <div class="title">{{'Stories.contact.hospital' | translatePipe | async}}</div>
        <div class="name"><a href="tel:{{fundraiser?.hospital?.phone_1}}" [ngClass]="{'disabled': !isMobile || !fundraiser?.hospital?.phone_1}" (click)="sendEvent('h')">{{fundraiser?.hospital?.full_name}}</a></div>
        <div *ngIf="fundraiser?.hospital?.phone_1 && !isMobile" class="cont">{{'Stories.contact.contact' | translatePipe | async}} <strong>{{fundraiser?.hospital?.phone_1}}</strong></div>
      </div>
    </div>
  </div>
  <div *ngIf="fundraiser?.hospital?.phone_1 && isMobile" class="contact-hospital">
    <a href="tel:{{fundraiser?.hospital?.phone_1}}" (click)="sendEvent('h')"><button mat-stroked-button>{{'Stories.contact.contacthospital' | translatePipe | async}}</button></a>
  </div>
  <div class="contact-ketto"><a href="tel:+91{{vars.contactUsMobNumber}}" (click)="sendEvent('k')" [ngClass]="{'disabled': !isMobile}"><i class="material-icons">call</i><span>{{'Stories.contact.further' | translatePipe | async}}</span><strong *ngIf="!isMobile">: +91 {{vars.contactUsMobNumber}}</strong></a></div>
</div>
